import { object, string, boolean, array, number, } from 'yup';
import { EmailTemplateTypes } from '../../constants';
import { SignaturePositions } from '../../models';
export const emailTemplateSchema = object({
    logo_url: string().url(`Logo URL is invalid`).nullable(),
    type: string().oneOf([
        EmailTemplateTypes.LATE_FEE,
        EmailTemplateTypes.REMINDER,
        EmailTemplateTypes.DISCOUNT,
        EmailTemplateTypes.STATEMENT_EMAIL,
        EmailTemplateTypes.STATEMENT_INTEREST_EMAIL,
        EmailTemplateTypes.AFTER_MARKED_PAID,
        EmailTemplateTypes.QUOTE,
        EmailTemplateTypes.ANNOUNCEMENT,
    ], 'Invalid Template Type').required(`Type is required`),
    main_html_content: string().required(`Email Content is required`),
    main_json_content: object().required(`Email Content is required`),
    include_upcoming_latefee: boolean().default(false).required(`Include upcoming late fee is required`),
    secondary_html_content: string().when('include_upcoming_latefee', {
        is: true,
        then: s => s.required(`Secondary email content is required when including upcoming late fee`),
        otherwise: s => s.nullable(),
    }),
    secondary_json_content: object().when('include_upcoming_latefee', {
        is: true,
        then: s => s.required(`Secondary email content is required when including upcoming late fee`),
        otherwise: s => s.nullable(),
    }),
    name: string().required(`Template name is required`),
    primary_color: string().required(`Primary color is required`),
    secondary_color: string().required(`Secondary color is required`),
    subject: string().required(`Subject is required`),
    suits_before_due: boolean(),
    suits_after_due: boolean(),
    suits_on_due: boolean(),
    attached_files: array().of(object({
        id: number().required(),
        filePath: string().required(),
        GCPBucketName: string().required(),
        mimeType: string().required(),
        size: number().required(),
        sizeFormatted: string().required(),
        uploadedAt: string().required(),
    })),
    signature_position: string().oneOf(Object.values(SignaturePositions)).nullable().optional(),
})
    .test('at-least-one-true', 'Template must suit at least one invoice state', obj => {
    if (obj.type !== EmailTemplateTypes.REMINDER)
        return true;
    return obj.suits_before_due || obj.suits_after_due || obj.suits_on_due;
});
//# sourceMappingURL=emailTemplate.js.map